import { gql } from "graphql-tag";

import { getSeoFields, getMetaFields } from "~/mixins/seoMixin";
import { memberCampaignBanner } from "~/slices/CampaignBanner/fragment";
import { memberBanner } from "~/slices/MemberBanner/fragment";
import { memberEventOffer } from "~/slices/MemberEventOffer/fragment";
import { getYotpoWidget } from "~/slices/YotpoWidget/fragment";
import { memberAlternateGrid } from "~/slices/MemberAlternateGrid/fragment";
import { campaignBannerV2 } from "~/slices/CampaignBannerV2/fragment";

const PAGE_TYPE = "Become_a_member";

const QUERY_BECOME_A_MEMBER = gql`
  query become_a_member($uid: String!, $lang: String = "en-in") {
    ${PAGE_TYPE}:become_a_member(uid: $uid, lang:$lang) {
      title
      button_label
      ...${PAGE_TYPE}SEOFields
      ...${PAGE_TYPE}MetaFields
      slices: body {
        ...${PAGE_TYPE}_campaign_banner
        ...${PAGE_TYPE}_member_banner
        ...${PAGE_TYPE}_Member_event_offer
        ...${PAGE_TYPE}_yotpo_widget
        ...${PAGE_TYPE}_Member_alternate_grid
        ...${PAGE_TYPE}_Campaign_Banner_V2
      }
    }
  }
  ${getYotpoWidget(PAGE_TYPE)}
  ${getSeoFields(PAGE_TYPE)}
  ${getMetaFields(PAGE_TYPE)}
  ${memberCampaignBanner}
  ${memberBanner}
  ${memberEventOffer}
  ${memberAlternateGrid}
  ${campaignBannerV2}
`;

export { PAGE_TYPE, QUERY_BECOME_A_MEMBER };
